import { render } from "./A3Form.vue?vue&type=template&id=204f4c16&scoped=true"
import script from "./A3Form.vue?vue&type=script&lang=js"
export * from "./A3Form.vue?vue&type=script&lang=js"

import "./A3Form.vue?vue&type=style&index=0&id=204f4c16&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-204f4c16"]])

export default __exports__